import type { GameLedgerPeriodDays } from '../types';
import { formatDateInTimezone } from './index';

const formatUtcDate = (value: Date): string => value.toISOString().slice(0, 10);

export function getLedgerDateRange(
  days: GameLedgerPeriodDays,
  timeZone?: string | null,
  now = new Date(),
): { startDate: string; endDate: string } {
  const endDate = formatDateInTimezone(now.toISOString(), timeZone) ?? formatUtcDate(now);
  const start = new Date(`${endDate}T00:00:00Z`);
  start.setUTCDate(start.getUTCDate() - (days - 1));
  return { startDate: formatUtcDate(start), endDate };
}
